module.exports = __webpack_public_path__ + "static/media/064.5eb3bd5d.jpg";